module.exports = __webpack_public_path__ + "img/about-left-shape.ee0bcf56.svg";